<div class="success-screen">

  <app-confetti></app-confetti>

  <div class="success-content">
    <div class="success-circle">
      <i class="material-icons success-check">check</i>
    </div>
    <div class="success-title">Welcome to TaxPlanIQ</div>
    <div class="success-subtitle">
      Your onboarding is complete.<br/>Now, we are redirecting to the dashboard.
    </div>
    <div class="success-redirect">Redirecting . . .</div>
  </div>

</div>
